import { render, staticRenderFns } from "./SMSHistory.vue?vue&type=template&id=018f2e52&"
import script from "./SMSHistory.vue?vue&type=script&lang=ts&"
export * from "./SMSHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports